export default __webpack_public_path__ + "static/media/ava-06.871cdb6e.png";